
import { Movil } from "./movil.model";
import { Gtp } from '../shared/gtp';

export class MovilRecorrido extends Movil {

    consumo?: any;
    nro_chasis?: any;
    eventos?: any;
    puntoscercanos?: any;
    duracion?: any;
    openinfo?: boolean = false;
    geoinversa?: string;
    geoinversapol?: string;
    markerSource?: string;

    constructor(data: any, imgIcon?: string) {
        //console.log(data)
        super();
        let gtp = new Gtp();

        let color = 'rojo';
        if(data.velocidad){
            color = ( Math.floor(data.velocidad) == 0) ? 'rojo' : 'verde';
        }
        if(data.ult_velocidad){
            color = ( Math.floor(data.ult_velocidad) == 0) ? 'rojo' : 'verde';
        }

        let duracion = gtp.getDuration(data.duration);
        this.cod_equipo_rastreo = data.cod_equipo_rastreo;
        this.des_equipo_ratreo = data.des_equipo_ratreo;
        this.fecha_hora = data.fecha_hora;
        this.latitud = parseFloat(data.latitud);
        this.longitud = parseFloat(data.longitud);
        this.matricula = data.matricula;
        this.nro_vehiculo = data.nro_vehiculo;
        this.orientacion = parseFloat(data.orientacion);
        this.velocidad = data.velocidad;
        this.consumo = data.consumo;
        this.nro_chasis = data.nro_chasis;
        this.color = color;
        this.eventos = data.eventos;
        this.puntoscercanos = false;
        this.label = data.cod_equipo_rastreo.toString();
        //this.duracion = (duracion!='00:00:00') ? duracion : false;
        this.duracion = (data.duration) ? gtp.getDuration(data.duration) : false;
        this.icono = this.mapIcon.getIcon(
            (imgIcon) ? imgIcon : "auto",
            color,
            parseFloat(data.orientacion)
        );
        this.markerSource = 'recorrido';

        this.geoinversa = data.direccion.formateada;
        this.geoinversapol = data.localidad;
    }

}
